.sectionTitle {
  margin-top: 16px;
  margin-bottom: 16px;
}

.description {
  margin-bottom: 24px;
}

.formField {
  margin-bottom: 24px;
}

.table {
  margin-bottom: 16px;
}

.blockCaption {
  display: block;
}

.noItems {
  margin-bottom: 16px;
}

.formRow {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: flex-end;
  margin-bottom: 16px;
}

.flexField {
  flex: 1;
}

.qtyField {
  width: 70px;
}

.categorySelect {
  min-width: 120px;
}
